import { pushToDataLayer } from "./analytics.js";

const fetchIPInfo = async (url, label) => {
  try {
    const token = document
      .querySelector('meta[name="ipinfo-token"]')
      ?.getAttribute("content");

    // Skip external API request if token is blank
    if (url === "https://ipinfo.io" && (!token || token.trim() === "")) {
      throw new Error("IPinfo token is not configured");
    }

    const response = await fetch(url, {
      headers:
        url === "https://ipinfo.io"
          ? {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            }
          : {},
    });

    if (!response.ok) throw new Error("Response not OK");

    const data = await response.json();

    // A rejected token comes back as HTTP 200 with an { error } body, so it
    // never throws and never reaches the catch below. Report it explicitly:
    // without this the server-side fallback could be broken for a year and
    // ip_fetch_failure would still read flat zero (#1079). The message is
    // fixed rather than upstream text to keep GA4 cardinality bounded.
    if (data.error) {
      pushToDataLayer("ip_fetch_failure", {
        error_message: `${label}: rejected by upstream`,
      });
      return null;
    }

    return data;
  } catch (error) {
    // GA4 parameters must be primitives - an Error object serialises to {}.
    // JS allows throwing non-Errors, so fall back rather than report undefined.
    //
    // Both endpoints report under one event with the failing one named in the
    // message, so a single GTM tag covers the pair.
    pushToDataLayer("ip_fetch_failure", {
      error_message: `${label}: ${error?.message ?? String(error)}`,
    });
    return null;
  }
};

export async function fetchVisitorIP() {
  const cacheKey = "ipinfo";
  const ttl = 86400000; // 24 hours
  const cachedItem = localStorage.getItem(cacheKey);
  if (cachedItem) {
    const { data, timestamp } = JSON.parse(cachedItem);
    if (timestamp + ttl > Date.now()) {
      return data;
    }
  }

  const data =
    (await fetchIPInfo("https://ipinfo.io", "ipinfo")) ||
    (await fetchIPInfo("/ipinfo", "local"));

  if (data) {
    localStorage.setItem(
      cacheKey,
      JSON.stringify({ data, timestamp: Date.now() }),
    );
  }

  return data;
}
